// unsaved-changes.guard.ts
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { DocuHubDetailPage } from '../pages/docu-hub-detail/docu-hub-detail.page';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesGuard implements CanDeactivate<DocuHubDetailPage> {
  canDeactivate(component: DocuHubDetailPage): boolean | Promise<boolean> {
    return component.canDeactivate();
  }
}
